import request from "@/utils/request";

export function list(data) {
  return request({
    url: "/student/statistics/supplement/list",
    method: "post",
    data,
  });
}

export function apply(data) {
  return request({
    url: "/student/statistics/supplement/apply",
    method: "post",
    data,
  });
}


export function networklist(data) {
  return request({
    url: "/student/statistics/network/list",
    method: "post",
    data,
  });
}


export function details(data) {
  return request({
    url: "/student/statistics/network/details",
    method: "post",
    data,
  });
}


export function traininglist(data) {
  return request({
    url: "/student/statistics/training/list",
    method: "post",
    data,
  });
}

export function recommonCourselist(data) {
  return request({
    url: "/student/statistics/network/details",
    method: "post",
    data,
  });
}
